<h2 mat-dialog-title>Impossibile inserire un messaggio.</h2>
<hr>
<mat-dialog-content class="mat-typography">
    <p>Non è possibile inserire un messaggio senza avere dei mittenti associati.</p>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-stroked-button mat-dialog-close>Chiudi</button>
</mat-dialog-actions>